import { MIN_ZOOM_LEVEL } from "./actions";

export const calculateOptimalZoom = (
  imageWidth: number,
  imageHeight: number,
  containerWidth: number,
  containerHeight: number
) => {
  if (
    imageWidth === 0 ||
    imageHeight === 0 ||
    containerWidth === 0 ||
    containerHeight === 0
  )
    return 1;

  // Calculate zoom to fit the entire image within the container with some padding
  const padding = 20; // 10px padding on each side
  const availableWidth = containerWidth - padding;
  const availableHeight = containerHeight - padding;

  // Calculate zoom factors for both dimensions
  const zoomX = availableWidth / imageWidth;
  const zoomY = availableHeight / imageHeight;

  // Use the smaller zoom factor to ensure the entire image fits
  const optimalZoom = Math.min(zoomX, zoomY);

  // Clamp between MIN_ZOOM_LEVEL and 1.0 to ensure it fits within viewable area
  return Math.min(Math.max(optimalZoom, MIN_ZOOM_LEVEL), 1.0);
};
